module.exports = __webpack_public_path__ + "img/StarOutline.e27fb2c4.png";